module.exports = __webpack_public_path__ + "img/meditation_5.9ef6d8f3.svg";